import React, { createContext, useContext, useState } from 'react';
import { initialData } from '../data/initialData';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [data, setData] = useState(initialData);

  const addItem = (section, item) => {
    setData(prev => ({
      ...prev,
      [section]: [...prev[section], { ...item, id: Date.now() }],
    }));
  };

  const updateItem = (section, id, updates) => {
    setData(prev => ({
      ...prev,
      [section]: prev[section].map(item => item.id === id ? { ...item, ...updates } : item),
    }));
  };

  const deleteItem = (section, id) => {
    setData(prev => ({
      ...prev,
      [section]: prev[section].filter(item => item.id !== id),
    }));
  };

  return (
    <DataContext.Provider value={{ data, addItem, updateItem, deleteItem }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
